require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-disability-rights-aiib.json") })
        }
      }, "path---en-us-update-disability-rights-aiib");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-disability-rights-aiib!./.cache/json/en-us-update-disability-rights-aiib.json
// module id = 655
// module chunks = 231608221292675